import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-comp-wa-stack',
	templateUrl:'./WaStackPage.html',
	styles: [],
	styleUrls:['./WaStackPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class WaStackPage
{
	mdContent_458 = `\`\`\`java
import com.jwebmp.webawesome.components.WaStack;
\`\`\``;
	mdContent_459 = `\`\`\`java
new WaStack<>()
\`\`\``;
	mdContent_460 = `\`\`\`java
var stack = new WaStack<>();
stack.setGap(PageSize.Medium);
stack.add(headingText("Title"));
stack.add(bodyText("Content"));
\`\`\``;
}
